<template>
  <div>
    <!--<div class="mt-2 mb-10">
     <h2 class="text-2xl font-semibold mb-1">Membership</h2>
      <p>Here you can upgrade, downgrade and cancel your membership</p>
    </div>-->

    <!--  <div
      :class="
        role == 'monthly'
          ? 'flex min-h-full items-center justify-center py-0 px-4 sm:px-6'
          : role == 'free'
          ? 'lg:px-3 grid max-w-4xl grid-cols-1 gap-3 mx-auto mt-8 sm:mt-16 sm:grid-cols-3'
          : 'lg:px-8 grid max-w-4xl grid-cols-1 gap-6 mx-auto mt-8 sm:mt-16 sm:grid-cols-2'
      "
    >
      <div
        v-for="plan in plans"
        :key="plan.id"
        class="bg-white border-4 hover:border-indigo-500 rounded-md"
        v-show="role == 'free' || (role == 'monthly' && plan.period == 'year')"
      >
        <div class="p-6 md:py-10 md:px-7">
          <div class="inline-block px-4 py-2 bg-gray-100 rounded-full">
            <h3 class="text-sm font-semibold text-gray-900">
              {{ plan.name }}
            </h3>
          </div>
          <br />

          <div v-if="plan.use_discount" class="inline-flex">
            <p class="mt-5 text-4xl text-grey line-through">
              <span class="text-black"> ${{ plan.price }} </span>
            </p>
            &nbsp;&nbsp;
            <p class="mt-5 text-4xl font-bold text-black">
              ${{ plan.discounted_price }}
            </p>
          </div>
          <p v-else class="mt-5 text-4xl font-bold text-black">
            ${{ plan.price }}
          </p>

          <p class="mt-2 text-base text-gray-600 mb-6">{{ plan.extras }}</p>

          <ul
            v-for="(features, index) in plan.features"
            :key="index"
            class="flex flex-col mt-2"
          >
            <li class="inline-flex items-center space-x-2">
              <svg
                class="flex-shrink-0 w-5 h-5 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="text-base font-medium text-gray-900">
                {{ features }}
              </span>
            </li>
          </ul>

          <a
            v-if="plan.period == 'month'"
            @click="buyMonthly"
            title=""
            class="inline-flex items-center justify-center w-full px-4 py-4 mt-8 font-semibold text-white transition-all duration-200 bg-indigo-500 rounded-md hover:bg-gray-600 focus:bg-gray-600"
            role="button"
          >
            Unlock Monthly
          </a>

          <a
            v-else
            @click="buyAnnual"
            title=""
            class="inline-flex items-center justify-center w-full px-4 py-4 mt-8 font-semibold text-white transition-all duration-200 bg-indigo-500 rounded-md hover:bg-gray-600 focus:bg-gray-600"
            role="button"
            >Unlock Annual</a
          >

          <p class="mt-5 text-sm text-gray-500"></p>
        </div>
      </div>
      <div class="bg-white border-4 hover:border-indigo-500 rounded-md" v-show="role == 'free'">
        <div class="p-6 md:py-10 md:px-7">
          <div class="inline-block px-4 py-2 bg-gray-100 rounded-full">
            <h3 class="text-sm font-semibold text-gray-900">
              Done for you
            </h3>
          </div>
          <br />

          <p class="mt-5 text-4xl font-bold text-black">
            $3500
          </p>
          <p class="mt-2 text-base text-gray-600 mb-6">Per month</p>

          <ul class="flex flex-col mt-2">
            <li class="inline-flex items-center space-x-2 pb-2">
              <svg
                class="flex-shrink-0 w-5 h-5 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="text-base font-medium text-gray-900">
                Will create your ad videos for you
              </span>
            </li>
            <li class="inline-flex items-center space-x-2 pb-2">
              <svg
                class="flex-shrink-0 w-5 h-5 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="text-base font-medium text-gray-900">
                Ads based in the performance of your account
              </span>
            </li>
            <li class="inline-flex items-center space-x-2 pb-2">
              <svg
                class="flex-shrink-0 w-5 h-5 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="text-base font-medium text-gray-900">
                Direct Response Copywriting
              </span>
            </li>
            <li class="inline-flex items-center space-x-2 pb-2">
              <svg
                class="flex-shrink-0 w-5 h-5 text-green-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <span class="text-base font-medium text-gray-900">
                30 min Call/Brand
              </span>
            </li>
          </ul>

          <br />
          <br />
          <br />
          <br />
          <br /><br /><br />

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScK5457wSWDFdbgixHpdCgG2_OtbLw9oS9UXl8eU8OVm9-TvQ/viewform"
            target="_blank"
            class="inline-flex items-center justify-center w-full px-4 py-4 mt-1 font-semibold text-white transition-all duration-200 bg-indigo-500 rounded-md hover:bg-gray-600 focus:bg-gray-600"
            role="button"
          >
            Contact us
          </a>
        </div>
      </div>

      <div class="flex mb-10">
        <div
          class="flex bg-white p-6 border shadow rounded-lg mr-10"
          v-if="subscription.state != 'deleted'"
        >
          <div
            class="bg-indigo-500 flex items-center text-white rounded-lg mr-3 p-2"
          >
            <Icon name="Clock" class="w-10 h-10" />
          </div>
          <div>
            <h3 class="text-base font-medium text-indigo-600 mb-1">
              Next Payment
            </h3>
            <p class="text-lg">
              {{
                subscription.next_payment
                  ? formatDate(subscription.next_payment.date)
                  : formatDate(subscription.payout_date)
              }}
            </p>
          </div>
        </div>

        <div class="flex bg-white p-4 border shadow rounded-lg mr-10" v-if="subscription.state != 'deleted'">
          <div
            class="bg-pink-500 flex items-center text-white rounded-lg mr-3 p-2"
          >
            <Icon name="EmojiSad" class="w-10 h-10" />
          </div>
          <div>
            <h3 class="text-base font-medium text-pink-600 mb-1">
              Cancel Membership
            </h3>
            <p class="text-lg mb-3">Good bye good friend</p>
            <a :href="subscription.cancel_url">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              >
                Cancel
              </button>
            </a>
          </div>
        </div>
        <div
          class="flex bg-white p-4 border shadow rounded-lg mr-10"
          v-if="role == 'monthly'"
        >
          <div
            class="bg-green-500 flex items-center text-white rounded-lg mr-3 p-2"
          >
            <Icon name="EmojiHappy" class="w-10 h-10" />
          </div>
          <div>
            <h3 class="text-base font-medium text-green-600 mb-8 pb-5">
              Upgrade Subscription
            </h3>

            <button
              @click="upgradeSubscription"
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              Upgrade
            </button>
          </div>
        </div>
      </div>

      <div class="flex bg-white p-4 border shadow rounded-lg mr-10" v-if="subscription.state == 'deleted'">
        <div
          class="bg-gray-500 flex items-center text-white rounded-lg mr-3 p-2"
        >
          <Icon name="EmojiSad" class="w-10 h-10" />
        </div>
        <div>
          <h3 class="text-base font-medium text-gray-800 mb-2">
            Account Inactive
          </h3>
          <p class="text-base mb-3">
            You have access to Adbox <br />
            until
            <strong class="font-semimedium text-gray-800">{{
              formatDate(user.cancellation_effective_date)
            }}</strong>
          </p>
        </div>
      </div>

      <div
        class="flex bg-white p-4 border shadow rounded-lg mr-10"
        v-if="subscription.state == 'deleted'"
      >
        <div
          class="bg-green-500 flex items-center text-white rounded-lg mr-3 p-2"
        >
          <Icon name="EmojiHappy" class="w-10 h-10" />
        </div>
        <div>
          <h3 class="text-base font-medium text-green-600 mb-3">
            Welcome Back
          </h3>
          <router-link
            :to="{ name: 'RepayMembership', plan_id: subscription.plan_id }"
          >
            <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              Reactivate Membership
            </button>
          </router-link>
        </div>
      </div>
      <div
        class="flex bg-white p-4 border shadow rounded-lg mr-10"
        v-if="subscription.state == 'deleted'"
      >
        <div
          class="bg-green-500 flex items-center text-white rounded-lg mr-3 p-2"
        >
          <Icon name="EmojiHappy" class="w-10 h-10" />
        </div>
        <div>
          <h3 class="text-base font-medium text-green-600 mb-3">
            Welcome Back
          </h3>
          <router-link
            :to="{ name: 'RepayMembership', plan_id: subscription.plan_id }"
          >
            <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              Upgrade
            </button>
          </router-link>
        </div>
      </div>
    </div>-->
    <div
      class="flex bg-white p-4 border shadow rounded-lg mr-10"
      v-if="
        subscription &&
          subscription.state != 'deleted' &&
          (role == 'monthly' || role == 'annual')
      "
    >
      <div class="bg-pink-500 flex items-center text-white rounded-lg mr-3 p-2">
        <Icon name="EmojiSad" class="w-10 h-10" />
      </div>
      <div class="mb-3">
        <h3 class="text-base font-medium text-pink-600 mb-1">
          Cancel Membership
        </h3>
        <p class="text-lg mb-3">Good bye good friend</p>
        <a :href="subscription.cancel_url">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          >
            Cancel
          </button>
        </a>
      </div>
    </div>
    <div class="my-6">
      <div class="flex justify-between items-center">
        <div>
          <h3 class="text-xl font-medium mb-1">Billing History</h3>
          <p class="mb-6">You can find your past payments here:</p>
        </div>
        <!--<a
          v-if="subscription.state != 'deleted'"
          class="text-sm bg-indigo-500 text-white py-3 px-4 rounded-lg"
          target="_blank"
          :href="subscription.update_url"
        >
          Change billing information
        </a>-->
      </div>
      <ul class="w-full">
        <li class="w-full grid grid-cols-12 justify-between py-3">
          <!-- <span class="col-span-1"></span> -->
          <p class="col-span-5 font-semibold">Date</p>
          <p class="col-span-2 font-semibold">Price</p>
          <p class="col-span-2 font-semibold">Status</p>
          <p class="col-span-3 font-semibold">Action</p>
        </li>
        <div v-if="subscription">
          <li
            v-for="item in subscription.payments"
            :key="item.id"
            class="w-full grid grid-cols-12 justify-between items-center py-3 border-t"
          >
            <Icon name="DocumentText" class="w-6 h-6 mx-auto" />
            <p class="col-span-4">{{ formatDate(item.payout_date) }}</p>
            <p class="col-span-2">{{ `${item.amount} ${item.currency}` }}</p>
            <div class="col-span-2 flex justify-start">
              <span
                class="flex items-center rounded-md bg-green-500 text-white py-1 px-2"
                v-if="item.is_paid"
              >
                <p class="text-sm font-medium">Paid</p>
              </span>
            </div>
            <a
              :href="item.receipt_url"
              target="_blank"
              class="col-span-3 text-base text-blue-500 cursor-pointer hover:text-blue-300"
              >See Receipt</a
            >
          </li>
        </div>
        <div v-if="transaction">
          <li
            v-show="transaction"
            class="w-full grid grid-cols-12 justify-between items-center py-3 border-t"
          >
            <Icon name="DocumentText" class="w-6 h-6 mx-auto" />
            <p class="col-span-4">{{ formatDate(transaction.created_at) }}</p>
            <p class="col-span-2">
              {{ `${transaction.amount} ${transaction.currency}` }}
            </p>
            <div class="col-span-2 flex justify-start">
              <span
                class="flex items-center rounded-md bg-green-500 text-white py-1 px-2"
                v-if="transaction.status == 'completed'"
              >
                <p class="text-sm font-medium">Paid</p>
              </span>
            </div>
            <a
              :href="transaction.receipt_url"
              target="_blank"
              class="col-span-3 text-base text-blue-500 cursor-pointer hover:text-blue-300"
              >See Receipt</a
            >
          </li>
        </div>
      </ul>
    </div>
    <Portal target="#confirm-upgrade">
      <ConfirmUpgrade v-model:isVisible="isConfirmVisible" />
    </Portal>
  </div>
  <!-- <div v-show="role === 'free'">
    <Plans />
  </div> -->
</template>

<script>
import { ref, computed, onMounted } from "vue";
import ConfirmUpgrade from "@/components/Modals/ConfirmUpgrade";
import { useStore } from "vuex";
import moment from "moment";

import Icon from "@/components/UI/Icon";
// import Plans from "@/components/Plans";

export default {
  components: { Icon, ConfirmUpgrade },
  setup() {
    const store = useStore();

    onMounted(async () => {
      store.dispatch("GET_TRANSACTION_BY_USER");
      store.dispatch("GET_SUBSCRIPTION_BY_USER");
    });

    const role = computed(() => store.state.role);
    const plans = computed(() => store.state.plans);
    const transaction = computed(() => store.state.transaction);
    const subscription = computed(() => store.state.subscription);

    const buyMonthly = () => {
      const plan_id = 589466;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const buyAnnual = () => {
      const plan_id = 636842;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const isConfirmVisible = ref(false);

    const upgradeSubscription = () => {
      isConfirmVisible.value = true;
    };

    const user = computed(() => store.state.user);
    const formatDate = (date) => {
      return moment(date).format("LL");
    };

    const openPlans = () => {
      store.commit("SET_OURPLANS_ACTIVE", true);
    };

    return {
      subscription,
      transaction,
      formatDate,
      user,
      role,
      openPlans,
      isConfirmVisible,
      upgradeSubscription,
      buyMonthly,
      buyAnnual,
      plans,
    };
  },
};
</script>

<style></style>
